import { Link } from "react-router-dom";

import { PLAYER_STAGE_LOCKED_MESSAGE, PLAYER_STAGE_SECTION_MESSAGES, type PlayerStageSection } from "../lib/playerStage";

/** Aviso fijo de estado (data-no-toast): la sección existe pero el admin aún
 * no termina el wizard (Eduardo 2026-09-24: la sección se ve, con su aviso). */
export default function PlayerStageLockedCard({ tournamentId, section }: { tournamentId: number | string; section: PlayerStageSection }) {
  return (
    <section className="card" data-no-toast role="status">
      <h2 className="card__title">{PLAYER_STAGE_SECTION_MESSAGES[section]}</h2>
      <p className="card__subtitle">{PLAYER_STAGE_LOCKED_MESSAGE}</p>
      <div className="form__actions">
        <Link className="btn btn--ghost" to={`/player/tournaments/${tournamentId}/players`}>
          Ver jugadores inscritos
        </Link>
      </div>
    </section>
  );
}
